import { VueQueryPlugin } from "@tanstack/vue-query";
import { queryClient } from "@verbleif/lib/src/composables/Query/queryClient";
import i18n from "@verbleif/lib/src/translations/i18n";
import { createApp } from "vue";
import App from "../App.vue";

const app = createApp(App);

app.use(i18n);
app.use(VueQueryPlugin, { queryClient });

export default app;
